/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfPreviewPanel = ({ file }) => {
  const [numPages, setNumPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  if (!file) {
    return (
      <Typography variant="body2" sx={{ color: 'text.secondary', py: 4, textAlign: 'center' }}>
        Nenhum arquivo PDF selecionado.
      </Typography>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Document
        file={file}
        onLoadSuccess={({ numPages: total }) => {
          setNumPages(total);
          setCurrentPage(1);
        }}
        loading={
          <Typography variant="body2" sx={{ color: 'text.secondary', py: 4, textAlign: 'center' }}>
            Carregando PDF...
          </Typography>
        }
        error={
          <Typography variant="body2" sx={{ color: 'error.main', py: 4, textAlign: 'center' }}>
            Não foi possível carregar o PDF.
          </Typography>
        }
      >
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Page
            pageNumber={currentPage}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            width={Math.min(window.innerWidth * 0.75, 720)}
          />
        </Box>
      </Document>
      <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
        <IconButton
          size="small"
          disabled={currentPage <= 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          <NavigateBeforeIcon />
        </IconButton>
        <Typography variant="body2" sx={{ minWidth: 80, textAlign: 'center' }}>
          {numPages ? `${currentPage} / ${numPages}` : '—'}
        </Typography>
        <IconButton
          size="small"
          disabled={!numPages || currentPage >= numPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          <NavigateNextIcon />
        </IconButton>
      </Stack>
    </Box>
  );
};

PdfPreviewPanel.propTypes = {
  file: PropTypes.any,
};

PdfPreviewPanel.defaultProps = {
  file: null,
};

export default PdfPreviewPanel;
